const setUnreadCount = (state, action) => action.unreadCount || state;
export default setUnreadCount;
